import Sentry from 'lib/sentry';

const initialState = {
  list: [],
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
  isLoading: false,
  faqDetail: {},
};

const getters = {
  getList: (state) => state.list,
  getMeta: (state) => state.meta,
  getIsLoading: (state) => state.isLoading,
  getFaqDetail: (state) => state.faqDetail,
};

const actions = {
  fetchFaqs({commit, rootState}, payload = {offset: 0, limit: 10, platform: 'dweb'}) {
    if (payload.offset === 0 && rootState.dataServer?.faqs?.list?.length > 0) {
      commit('setFaqs', {faqs: rootState.dataServer?.faqs?.list || [], meta: rootState.dataServer?.faqs.meta});
      return;
    }
    commit('setIsLoading', true);
    const platform = payload.platform;
    delete payload.platform;

    return this.$api
      .getArticles({
        ...payload,
        category_id: process.env.ARTICLES_CATEGORY_ID,
      })
      .then(({data, meta}) => {
        if (platform === 'mweb' && payload.offset > 0) {
          commit('setLazyFaqs', {faqs: data, meta});
          commit('setIsLoading', false);
          return;
        }
        commit('setFaqs', {faqs: data, meta});
        commit('setIsLoading', false);
      })
      .catch((e) => {
        commit('setFaqs', {
          faqs: [],
          meta: {
            limit: payload.limit,
            offset: payload.offset,
            total: 0,
          },
        });
        commit('setIsLoading', false);
        Sentry.log('fetchFaqs', e);
      });
  },

  fetchFaqDetail({commit, rootState}, payload = {article_id: 0}) {
    if (rootState.dataServer?.faqDetail) {
      commit('setFaqDetail', rootState.dataServer?.faqDetail);
      return;
    }
    commit('setIsLoading', true);
    return this.$api
      .getArticleDetail({
        article_id: payload.article_id,
      })
      .then(({data}) => {
        commit('setFaqDetail', data);
        commit('setIsLoading', false);
      })
      .catch((e) => {
        commit('setFaqDetail', null);
        commit('setIsLoading', false);
        Sentry.log('fetchFaqDetail', e);
      });
  },
};

const mutations = {
  setFaqs(state, data) {
    state.list = data.faqs;
    state.meta = data.meta;
  },

  setLazyFaqs(state, data) {
    state.list = [...state.list, ...data.faqs];
    state.meta = data.meta;
  },

  setFaqDetail(state, data) {
    state.faqDetail = data;
  },

  setIsLoading(state, data) {
    state.isLoading = data;
  },
};

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations,
};
